import Consult from "../../assets/images/Product/About.jpg";
import "./choose.css";
import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";

export default function Choose() {
    return (
        <>
            <section className="consult-one choose-product-hwpl">
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="consult-one_content-column col-lg-6 col-md-12 col-sm-12">
                            <div className="consult-one_column-inner">
                                <div className="sec-title-three style-two">
                                    <div className="sec-title_title">Why Clients Trust</div>
                                    <h2 className="sec-title_heading">
                                        Why Businesses Choose Horizon Webinfo
                                    </h2>
                                </div>

                                <div className="row clearfix">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <ul className="consult-one">
                                            <li>
                                               <FaCheckCircle /> 10+ years of software development expertise
                                            </li>
                                            <li>
                                               <FaCheckCircle /> 100+ successful projects across industries
                                            </li>
                                            <li>
                                               <FaCheckCircle /> Strong support team for long-term maintenance
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <ul className="consult-one">
                                            <li>
                                               <FaCheckCircle /> Customized solutions tailored to your business
                                            </li>
                                            <li>
                                               <FaCheckCircle /> Trusted by clients across India & abroad
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* Button Box */}
                                <div className="consult-one_button-box">
                                    <a
                                        className="btn-style-twelve theme-btn btn-item"
                                        
                                    >
                                        <div className="btn-wrap">
                                            <Link to='/company/about'> <span className="text-one">Learn More</span></Link>
                                            <Link to='/company/about'> <span className="text-two">Learn More</span></Link>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="consult-one_image-column col-lg-6 col-md-12 col-sm-12">
                            <div className="consult-one_image-inner">
                                <div className="consult-one_image">
                                    <img src={Consult} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}